/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import * as HERBUI from "react-bootstrap";
import "../loginandlandingpage.css";
import * as Yup from 'yup';
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { LOGIN_DOMAIN, LOGIN_API_UPDATED } from "../Api/APIURLS";
import { useDispatch } from "react-redux";
import { CommonAjaxPostLoginRequest, CommonAjaxPostLoginRequestUpdated } from '../Api/CommonAjaxUtils'
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Sweetalert, { formatCountdown, getClockSkew, origins, startOtpTimer } from "../components/Functions";
import Swal from "sweetalert2";
import MobileNumbersPopUp from "./MobileNumbersPopUp";
// import PensionsMobileNumbersPopUp from "./PensionsMobileNumbersPopUp";
import LoginHeaderNavBar from "./LoginHeaderNavBar";
var createHost = require('cross-domain-storage/host');
var createGuest = require('cross-domain-storage/guest');
const LoginPageUpdated = () => {
    var storageHost = null;
    var mainAppguest = null;
    const [errorMsg, setErrorMsg] = useState('')
    const [otpStatus, setOtpStatus] = useState('')
    const [showFields, setShowFields] = useState(false)
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const [showpopup, setShowPopup] = useState(false);
    // const [showPensionspopup, setShowPensionsPopup] = useState(false);
    // const handleOpen = () => setShowPopup(true);
    const handleClose = () => setShowPopup(false);
    const [showFieldsOtp, setShowFieldsOtp] = useState(false);
    const [remainingTime, setRemainingTime] = useState(0);
    const [showTimer, setShowTimer] = useState(false);
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const inputRefs = useRef([]);
    const [resendAttempts, setResendAttempts] = useState(
        Number(localStorage.getItem("resendAttempts")) || 0
    );

    const LOGIN_STAGE = {
        GET_OTP: "GET_OTP",
        VERIFY_OTP: "VERIFY_OTP",
        LOGIN: "LOGIN"
    };

    const [loginStage, setLoginStage] = useState(LOGIN_STAGE.GET_OTP);

    const handleResendOtp = async () => {

        const challengeExpiresAt = formik.values.challengeExpiresAt;
        const resendAttempts = Number(localStorage.getItem("resendAttempts") || 0);
        const lastResendTime = Number(localStorage.getItem("lastResendTime") || 0);

        // OTP expired
        if (Date.now() >= challengeExpiresAt * 1000) {
            Swal.fire({
                icon: "warning",
                text: "OTP has expired."
            });
            return;
        }

        // Maximum 3 attempts
        if (resendAttempts >= 2) {
            Swal.fire({
                icon: "warning",
                text: "Maximum resend attempts reached."
            });
            return;
        }

        // Allow resend only once every minute
        if (
            lastResendTime &&
            Date.now() - lastResendTime < 60000
        ) {
            Swal.fire({
                icon: "warning",
                text: "Please wait before requesting another OTP."
            });
            return;
        }

        const response = await resendOtpApi();

        if (response) {

            // DON'T update challengeExpiresAt
            // It remains the original value

            localStorage.setItem(
                "resendAttempts",
                resendAttempts + 1
            );

            localStorage.setItem(
                "lastResendTime",
                Date.now()
            );

            Swal.fire({
                icon: "success",
                text: "OTP resent successfully."
            });
        }
    };

    const resendOtpApi = async () => {

        const params = {
            // username: formik.values?.username,
            challengeId: formik.values.challengeId // if required
        };
        // const params = {
        //     username: JSON.parse(localStorage.getItem("userName")),
        //     challengeId: localStorage.getItem("challengeId") // if required
        // };

        try {
            const response = await CommonAjaxPostLoginRequest(
                LOGIN_API_UPDATED + "auth/resend-otp",
                params
            );
            if (response.status === 200) {


                if (response?.data?.challengeExpiresAt) {

                    // Update expiry time
                    formik.setFieldValue('challengeExpiresAt', response?.data?.challengeExpiresAt)
                    // localStorage.setItem(
                    //     "challengeExpiresAt",
                    //     response.challengeExpiresAt
                    // );
                }

                return response;
            }
            else {
                dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
                setErrorMsg(response?.data);
            }
        } catch (err) {
            // console.log("Resend OTP Error", err);
            return null;
        }
    };


    const formattedTime = formatCountdown(remainingTime);

    const intialValues = {
        username: '', password: '', otp: "", name: "", mobileNo: "", mfaRequired: false,
        email: "", uid: "", trn: "", OTpValidation: '', aadhaarType: '', showPassword: false,
        challengeId: '', challengeExpiresAt: '', successMsg: '', showLoginButton: false
    }
    const [buttonType, setButtonType] = useState("")
    const [passwordType, setPasswordType] = useState("password");



    useEffect(() => {
        storageHost = createHost(
            origins.map(origin => ({ origin, allowedMethods: ['get', 'set', 'remove'] }))
        );
    }, [])

    useEffect(() => {
        if (remainingTime === 0) {
            // setErrorMsg("");
            setShowTimer(false);
        }
    }, [remainingTime])

    const getValidationSchema = () => {
        switch (loginStage) {
            case LOGIN_STAGE.GET_OTP:
                return Yup.object({
                    username: Yup.string()
                        .required("Required."),
                    password: Yup.string()
                        .required("Required.")
                });
            case LOGIN_STAGE.VERIFY_OTP:
                return Yup.object({
                    otp: Yup.string()
                        .required("OTP is required.")
                        .matches(/^\d{6}$/, "OTP must be exactly 6 digits.")
                });

            default:
                return Yup.object({});
        }

    };

    const formik = useFormik({
        initialValues: intialValues,
        validationSchema: getValidationSchema(),
        onSubmit: (values) => {
            if (buttonType === "go") {
                let params = { "username": values.username, clientId: 'nidhi', password: values.password }
                // CommonAjaxGetRequestWithOutParamsWithOutAuthorization(USER_VERIFICATION + values.username).then((res) => {
                CommonAjaxPostLoginRequestUpdated(LOGIN_API_UPDATED + 'auth/login', params).then((response) => {
                    if (response) {
                        if (response?.status === 200) {
                            handleSuccessResponse(response, values);
                        }
                        else {
                            handleFailureResponse(response);
                        }
                    }
                }).catch((err) =>
                    console.log("error in login page ... ", err)
                )

            }
            else if (buttonType === "SignIn") {
                localStorage.removeItem("token");
                localStorage.removeItem("serviceList");
                localStorage.clear();
                localStorage.setItem('userId', values.username)
                localStorage.setItem('userName', JSON.stringify(values.username))
                let params = { challengeId: formik.values?.challengeId, otp: formik.values?.otp }

                CommonAjaxPostLoginRequestUpdated(LOGIN_API_UPDATED + 'auth/verify-otp', params).then((response) => {
                    if (response) {
                        if (response?.status === 200) {
                            handleSuccessResponse(response, values);
                        }
                        else {
                            handleFailureResponse(response);
                        }
                    }
                }).catch((err) => console.log("error in login page ... ", err))

            }
        }
    });

    const handleFailureResponse = (res) => {
        dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
        if (res?.status === 408 && buttonType === 'SignIn') {
            formik.setFieldValue('showLoginButton', true);
            setErrorMsg(res?.data?.errorMessage);
            setRemainingTime(0);
            setShowTimer(false);
            Sweetalert(res?.data?.errorMessage, 'warning').then(function (isConfirm) {
                if (isConfirm.value) {
                    // history.push('/loginPageUpdated');
                    window.location.href = '/loginPageUpdated';
                }
            })
            return;
        }
        // if (res?.status === 401) {
        //     Sweetalert(res?.data?.errorMessage, 'warning').then(function (isConfirm) {
        //         if (isConfirm.value) {
        //             window.location.href = '/loginPageUpdated';
        //             // history.push('/loginPageUpdated');
        //         }
        //     })
        //     return;
        // }
        if (res?.status === 410) {
            Sweetalert(res?.data?.errorMessage, 'warning').then(function (isConfirm) {
                if (isConfirm.value) {
                    window.location.href = '/loginPageUpdated';
                    // history.push('/loginPageUpdated');
                }
            })
            return;
        }
        if (res?.status === 429) {
            Sweetalert(res?.data?.errorMessage, 'warning').then(function (isConfirm) {
                if (isConfirm.value) {
                    window.location.href = '/loginPageUpdated';
                    // history.push('/loginPageUpdated');
                }
            })
            return;
        }
        if (res?.data) {
            setErrorMsg(res?.data?.errorMessage);
            if (buttonType === 'SignIn') {
                if (res?.data?.tokenExpiresAt) {
                    startOtpTimer(res?.data?.tokenExpiresAt, setRemainingTime, getClockSkew(res?.headers));
                    // startOtpTimer(res?.data?.tokenExpiresAt, setRemainingTime);
                    setShowTimer(true);
                }
            }


        }
    }

    const handleSuccessResponse = (res, values) => {
        let response = res?.data;
        setErrorMsg("");
        formik.setFieldValue('mfaRequired', response?.mfaRequired);
        formik.setFieldValue('challengeId', response?.challengeId);
        formik.setFieldValue('challengeExpiresAt', response?.challengeExpiresAt);

        localStorage.setItem("token", JSON.stringify(response.access_token));
        localStorage.setItem("refresh_token", JSON.stringify(response.refresh_token));
        localStorage.setItem('userData', JSON.stringify(response))
        localStorage.setItem('userName', JSON.stringify(values.username))
        if (response?.mfaRequired === true) {
            setOtpStatus(true);
            formik.setFieldValue('successMsg', response?.message);
            setShowFields(true);
            const clockSkewMs = getClockSkew(res?.headers);
            startOtpTimer(response.challengeExpiresAt, setRemainingTime, clockSkewMs);
            // startOtpTimer(response.challengeExpiresAt, setRemainingTime);
            setShowTimer(true);
            if (buttonType === "go") {
                setLoginStage(LOGIN_STAGE.VERIFY_OTP);
            }
            else if (buttonType === "SignIn") {
                setLoginStage(LOGIN_STAGE.LOGIN);
            }
        }
        if (response?.passwordExpiry === true) {
            history.push({
                pathname: "/changePassword",
                state: {
                    type: 'loginPageRedirection'
                }
            });
            return;
        }
        if (response?.message) {
            localStorage.setItem("expirationErrorMsg", JSON.stringify(response?.message))
        }
        mainAppguest = createGuest(LOGIN_DOMAIN);
        let displayName = ""
        const base64Url = response?.access_token.split('.')[1];
        if (base64Url !== undefined) {
            const base64 = base64Url.replace('-', '+').replace('_', '/');
            displayName = JSON.parse(window.atob(base64)).name
            localStorage.setItem('displayName', JSON.stringify(displayName))
        }
        // const refreshTokenUrl = response?.refresh_token.split('.')[1];
        // console.log("refreshTokenUrl ..", refreshTokenUrl);
        // if (refreshTokenUrl !== undefined) {
        //     const base64 = base64Url.replace('-', '+').replace('_', '/');
        //     console.log(" base64 refreshTokenUrl ..", base64);
        //     let refreshData = JSON.parse(window.atob(base64));
        //     // let refreshData = JSON.parse(window.atob(base64)).name;
        //     console.log(" refreshData ..", refreshData);
        //     // localStorage.setItem('displayName', JSON.stringify(displayName))
        // }
        mainAppguest.set('token', JSON.stringify(response.access_token), function (error, data) {
            // foo is now set to 'bar'
        });
        mainAppguest.set('displayName', JSON.stringify(displayName), function (error, data) {
            // foo is now set to 'bar'
        });
        mainAppguest.set('userData', JSON.stringify(response), function (error, data) {
            // foo is now set to 'bar'
        });
        mainAppguest.set('refresh_token', JSON.stringify(response.refresh_token), function (error, data) {
            // foo is now set to 'bar'
        });
        mainAppguest.set('userId', JSON.stringify(values.username), function (error, data) {
            // foo is now set to 'bar'
        });
        history.push("/dashboard");
    }


    // function knowYourChallan() {
    //     history.push('/knowYourCfmsId')
    // }
    function forgotPassword() {
        history.push("/forgotPassword");
    }
    // function gos() {
    //     history.push("/gos");
    // }
    // function newAlerts() {
    //     history.push("/budgetRelatedPdfDetails");
    // }
    // function usermanuals() {
    //     history.push("/usermanuals")
    // }
    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }

    const handleChange = (value, index) => {
        // Allow only one digit
        if (!/^\d?$/.test(value)) {
            return;
        }

        const newOtp = [...otp];
        newOtp[index] = value;

        setOtp(newOtp);

        // Store complete OTP in Formik
        formik.setFieldValue("otp", newOtp.join(""));
        formik.setFieldTouched("otp", true, false);

        // Move to next input
        if (value && index < otp.length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        // Backspace
        if (e.key === "Backspace") {
            if (otp[index]) {
                // Clear current box
                const newOtp = [...otp];
                newOtp[index] = "";

                setOtp(newOtp);
                formik.setFieldValue("otp", newOtp.join(""));
            } else if (index > 0) {
                // Move to previous box and clear it
                const newOtp = [...otp];
                newOtp[index - 1] = "";

                setOtp(newOtp);
                formik.setFieldValue("otp", newOtp.join(""));

                inputRefs.current[index - 1]?.focus();
            }
        }

        // Move to previous box
        if (e.key === "ArrowLeft" && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }

        // Move to next box
        if (e.key === "ArrowRight" && index < otp.length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    return (
        <>
            <div className="loginnewwholediv">
                <FormikProvider value={formik}>
                    <LoginHeaderNavBar />
                    <img src="img/corner.svg" className="corner" alt="dots" />
                    <div className={`loginnew-form ${showFieldsOtp ? "otp-visible" : "otp-hidden"}`} autoComplete="off">
                        <div className="login-form-main">
                            <form className="" onSubmit={formik.handleSubmit}>
                                <input
                                    type="text"
                                    name="chrome_dummy_username"
                                    autoComplete="username"
                                    style={{ display: "none" }}
                                />
                                <input
                                    type="password"
                                    name="chrome_dummy_password"
                                    autoComplete="new-password"
                                    style={{ display: "none" }}
                                />
                                <div className="inner-herbpage-service-title-sub-np">
                                    <h1 style={{ fontSize: '22px' }}> Login </h1>
                                </div>
                                <HERBUI.InputGroup className="mb-3 form-floating">
                                    <Field name="username" placeholder="User ID" id="ids" type="text" aria-label="User ID" aria-describedby="basic-addon1"
                                        maxLength={10} disabled={loginStage !== LOGIN_STAGE.GET_OTP}
                                        className="form-control rounded"
                                        autoComplete="new-username" />
                                    <label for="ids">User ID</label>
                                    <ErrorMessage name="username" className="text-error" component="div" />
                                </HERBUI.InputGroup>
                                <HERBUI.InputGroup className="mb-3 form-floating" >
                                    <Field placeholder="Enter Password" name="password" type={passwordType} aria-label="Password" aria-describedby="basic-addon1"
                                        className="form-control rounded" id="passwords" disabled={loginStage !== LOGIN_STAGE.GET_OTP}
                                        onChange={(e) => {
                                            formik.setFieldValue("password", (e.target.value + "").trim())
                                        }} autoComplete="new-password"
                                    />
                                    <label for="passwords">Password</label>
                                    <HERBUI.InputGroup.Text id="basic-addon2 " className="basic-addon2">
                                        {passwordType === "password" ? <FaEyeSlash onClick={togglePassword} disabled={loginStage !== LOGIN_STAGE.GET_OTP} /> : <FaEye onClick={togglePassword} disabled={loginStage !== LOGIN_STAGE.GET_OTP} />}
                                    </HERBUI.InputGroup.Text>
                                    <ErrorMessage className="text-error" name="password" component={"div"} />
                                </HERBUI.InputGroup>

                                {showFields === false &&
                                    <button type="submit" className="btn btn-success rounded ms-2" onClick={() => setButtonType("go")}>Continue</button>}

                                {showFields &&
                                    <>
                                        {
                                            formik.values?.mfaRequired === true &&
                                            <>
                                                <HERBUI.InputGroup className="mb-1">
                                                    <span className="label-text-style"  ><span className="mandatory" >*</span>Enter the OTP : </span>
                                                    <div className="herb-otp mt-1">
                                                        {otp.map((digit, index) => (
                                                            <input
                                                                key={index}
                                                                type="text"
                                                                maxLength={1}
                                                                value={digit}
                                                                ref={(el) => (inputRefs.current[index] = el)}
                                                                onChange={(e) => handleChange(e.target.value, index)}
                                                                onKeyDown={(e) => handleKeyDown(e, index)}
                                                            />
                                                        ))}
                                                    </div>
                                                    <ErrorMessage className="text-error" name="otp" component="div" />
                                                </HERBUI.InputGroup>
                                                {/* <HERBUI.InputGroup className="mb-3 form-floating">
                                                    <Field placeholder="Enter OTP" id="otp" name="otp" type="text" aria-label="OTP" maxLength={6}
                                                        aria-describedby="basic-addon1" className="form-control rounded" autoComplete="off"
                                                        onChange={(e) => {
                                                            formik.setFieldValue('otp', e.target.value)
                                                        }}
                                                    />
                                                    <label for="otp">OTP</label>
                                                    <ErrorMessage className="text-error" name="otp" component={"div"} />
                                                </HERBUI.InputGroup> */}
                                            </>
                                        }

                                        <div className="">
                                            {
                                                formik.values?.mfaRequired === true && formik.values?.successMsg &&
                                                <div>
                                                    <span className="text-success">{formik.values?.successMsg}</span>
                                                </div>
                                            }
                                            {showTimer &&
                                                <small className="text-danger d-block otp-time mb-1">
                                                    OTP expires in <strong>{formattedTime}</strong>
                                                </small>
                                            }
                                            {/* {console.log("remaining time .. ", remainingTime)} */}


                                            {/* {remainingTime > 0 && resendAttempts < 3 && (
                                                <button
                                                    type="button"
                                                    // className="btn btn-link p-0"
                                                    onClick={handleResendOtp}
                                                    disabled={
                                                        resendAttempts > 0 &&
                                                        (Date.now() -
                                                            Number(localStorage.getItem("lastResendTime"))) < 60000
                                                    }
                                                >
                                                    Resend OTP ({2 - resendAttempts} left)
                                                </button>
                                            )} */}

                                            {/* {resendAttempts >= 2 && (
                                                <small className="text-danger">
                                                    Maximum resend attempts reached
                                                </small>
                                            )} */}

                                            {remainingTime === 0 && (
                                                <small className="text-danger">
                                                    OTP has expired
                                                </small>
                                            )}
                                        </div>
                                    </>
                                }
                                {
                                    errorMsg &&
                                    <div>
                                        <span className="text-danger">{errorMsg} </span>
                                    </div>
                                }

                                {/* {formik.values.mfaRequired === true &&
                                    <button className="link-button" type="button" onClick={() => window.location.reload()}>Click here to Login</button>
                                } */}
                                <div className="d-grid gap-2">
                                    {showFields &&
                                        <HERBUI.Button variant="primary" type="submit" className="btn_primary signin-bg rounded" onClick={() => setButtonType("SignIn")}
                                            disabled={formik.values.otp?.length !== 6}>
                                            Sign in
                                        </HERBUI.Button>
                                    }
                                    <a className="text-center forgot mb-4" style={{ zIndex: "9994" }} onClick={() => forgotPassword()} onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            forgotPassword()
                                        }
                                    }}>Forgot Password ?</a>
                                </div>
                            </form>
                        </div>
                        <div className='alert alert-danger mb-2 login-alert'>
                            <strong>Note:</strong>  A service titled <strong>"USC Number Confirmation"</strong> has been developed in <strong>CFMS</strong> to capture the Unique Service Connection (USC) details used by DDOs. Confirmation of USC details is mandatory for the implementation of the prepaid metering system. All DDOs are requested to complete the USC confirmation to avoid any inconvenience. If you have already completed the USC confirmation, kindly ignore this notification.
                        </div>
                    </div>

                    <MobileNumbersPopUp showpopup={showpopup} handleClose={handleClose} />
                    {/* <PensionsMobileNumbersPopUp showpopup={showPensionspopup} handleClose={handleClosePensions} /> */}
                </FormikProvider>
            </div>
        </>
    );
}
export default LoginPageUpdated;